<template>
  <el-select
    v-model="valueBackup"
    placeholder="请选择课卡期限类型"
    :style="width ? `width: ${width}` : ''"
    @change="handleChange"
    :multiple="multiple"
    :clearable="clearable"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    multiple: Boolean,
    clearable: Boolean,
  },
  data: () => ({
    valueBackup: '',
    list: [
      {
        id: 0,
        name: '通卡（仅限制使用时间）',
      },
      {
        id: 1,
        name: '次卡（限制时间及次数）',
      },
    ],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }
  },
};
</script>
